import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import {
  CreateRegionDto,
  RegionDto,
  SetRegionBranchesDto,
  UpdateRegionDto,
} from '../../../core/data/new-dtos/region.dtos';

@Injectable({ providedIn: 'root' })
export class RegionsService extends BaseCrudService<RegionDto> {
  controller = 'Banks';

  // GET /api/Banks/{bankId}/regions
  getRegions(bankId: number): Observable<RegionDto[]> {
    return this.httpClient.get<RegionDto[]>(`${this.controller}/${bankId}/regions`);
  }

  // POST /api/Banks/{bankId}/regions
  createRegion(bankId: number, dto: CreateRegionDto): Observable<RegionDto> {
    return this.httpClient.post<RegionDto>(`${this.controller}/${bankId}/regions`, dto);
  }

  // PUT /api/Banks/regions/{regionId}
  updateRegion(regionId: number, dto: UpdateRegionDto): Observable<RegionDto> {
    return this.httpClient.put<RegionDto>(`${this.controller}/regions/${regionId}`, dto);
  }

  // DELETE /api/Banks/regions/{regionId}
  deleteRegion(regionId: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.controller}/regions/${regionId}`);
  }

  // PUT /api/Banks/regions/{regionId}/branches
  setRegionBranches(regionId: number, dto: SetRegionBranchesDto): Observable<RegionDto> {
    return this.httpClient.put<RegionDto>(`${this.controller}/regions/${regionId}/branches`, dto);
  }
}
